module.exports = __webpack_public_path__ + "img/image-class.519ef0a2.svg";